<script>
import { mapActions, mapState } from 'vuex';
import TwTitleBar from '../../components/TwTitleBar';
import GiftVoucherTemplateEdit from '../../components/gift-voucher-templates/GiftVoucherTemplateEdit';

export default {
  name: 'GiftVoucherTemplates',
  components: {
    TwTitleBar,
    GiftVoucherTemplateEdit,
  },
  props: ['id'],
  data() {
    return {
      headers: [
        { text: this.$t('giftVoucherTemplates.table.name'), value: 'name' },
        { text: this.$t('giftVoucherTemplates.table.duration'), value: 'monthsValidFor' },
        { text: this.$t('giftVoucherTemplates.table.emailSubject'), value: 'emailSubject' },
        { text: this.$t('giftVoucherTemplates.table.pdfName'), value: 'pdfName' },
        { text: this.$t('giftVoucherTemplates.table.created'), value: 'createdAt' },
        { text: this.$t('giftVoucherTemplates.table.updated'), value: 'updatedAt' },
        { text: this.$t('giftVoucherTemplates.table.action'), sortable: false, width: '25px' },
      ],
      pagination: {
        rowsPerPage: 25,
        page: 1,
        sortBy: 'created',
      },
      edit: false,
      template: undefined,
      type: 'create',
    };
  },
  methods: {
    ...mapActions({
      setDomain: 'giftVoucherTemplates/setDomain',
      getDomains: 'giftVoucherTemplates/getDomains',
    }),
    editTemplate(template) {
      this.template = template;
      this.edit = !this.edit;
      this.type = 'edit';
    },
    deleteTemplate() {
      // TODO: Implement delete function
    },
    domainChanged(domainId) {
      const foundDomain = this.domains.items.find(domain => domain.id === domainId);
      this.setDomain(foundDomain);
    },
    createTemplate() {
      this.template = {};
      this.edit = !this.edit;
      this.type = 'create';
    },
  },
  computed: {
    ...mapState({
      domains: state => state.giftVoucherTemplates.domains,
      templates: state => state.giftVoucherTemplates.templates,
      domain: state => state.giftVoucherTemplates.domain,
    }),
    breadcrumbs() {
      return {
        title: this.$t('giftVoucherTemplates.title'),
        breadcrumbs: [
          { text: this.$t('navigationSubheadings.webContent'), to: '', disabled: true },
          { text: this.$t('giftVoucherTemplates.title'), to: this.$route.path },
        ],
      };
    },
  },
  filters: {
    dateFormat(date, moment) {
      if (!date) {
        return '-';
      }
      return moment.utc(date).local().format('Y-MM-DD HH:mm:ss');
    },
  },
  mounted() {
    if (this.domains.items && !this.domains.loading) {
      this.getDomains();
    }
  },
};
</script>

<template>
  <v-content>
    <v-flex>
      <template v-if="breadcrumbs">
        <tw-title-bar
          :title="breadcrumbs.title"
          :breadcrumbs="breadcrumbs.breadcrumbs"
        />
      </template>
      <v-container>
        <v-layout row>
          <v-flex xs12>
            <v-card>
              <v-container grid-list>
                <v-layout row>
                  <v-flex xs6>
                    <v-select
                      @change="domainChanged"
                      :items="domains.items"
                      :label="$t('giftVoucherTemplates.domains.label')"
                      :loading="domains.loading"
                      :disabled="domains.loading || domains.error || templates.loading"
                      item-value="id"
                      item-text="name"
                      dense
                    />
                  </v-flex>
                  <v-flex v-if="domain" xs6>
                    <v-btn
                      @click="createTemplate"
                      :disabled="templates.loading"
                      color="blue"
                      class="white--text gift-voucher-templates__create"
                    >
                      {{ $t('giftVoucherTemplates.edit.create') }}
                    </v-btn>
                  </v-flex>
                </v-layout>

                <v-layout row>
                  <v-flex xs12>
                    <v-data-table
                      :headers="headers"
                      :pagination.sync="pagination"
                      :items="templates.items"
                      :loading="templates.loading"
                    >
                      <template v-slot:items="props">
                        <tr>
                          <td>{{ props.item.name }}</td>
                          <td>
                            {{ props.item.monthsValidFor }}
                            {{
                              $tc('giftVoucherTemplates.table.months', props.item.monthsValidFor)
                            }}
                          </td>
                          <td>{{ props.item.emailSubject }}</td>
                          <td>{{ props.item.pdfName }}</td>
                          <td>{{ props.item.createdAt | dateFormat($moment) }}</td>
                          <td>{{ props.item.updatedAt | dateFormat($moment) }}</td>
                          <td class="d-flex align-center">
                            <v-btn @click="editTemplate(props.item)" color="blue" small>
                              <v-icon color="white" small>create</v-icon>
                            </v-btn>
                            <v-btn
                              @click="deleteTemplate(props.item)"
                              :disabled="true"
                              color="red"
                              small
                            >
                              <v-icon color="white" small>delete</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-flex>
                </v-layout>

                <gift-voucher-template-edit
                  :show="edit"
                  :template="template"
                  :type="type"
                />
              </v-container>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
  </v-content>
</template>

<style lang="scss">
  .gift-voucher-templates {
    &__create {
      float: right;
      margin-top: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/gift-voucher-templates/GiftVoucherTemplates.vue